// @ts-nocheck
import React, { useState, FormEvent } from 'react'
import { useApi } from '../../../hooks/useApi'
import MiniSwitch from '../../formUtils/MiniSwitch'
import CustomInput from '../../general/Form'
import styled from 'styled-components'

interface Web3FormProps {
  onSuccess?: () => void
}

const Web3Form: React.FC<Web3FormProps> = ({ onSuccess = () => {} }) => {
  const { callApi } = useApi()
  const [formValues, setFormValues] = useState({
    chainId: 0,
    active: false,
    url: '',
    type: '',
    score: 0,
  })
  const [message, setMessage] = useState<string>('')

  const handleFormSubmit = async (e: FormEvent) => {
    e.preventDefault()
    try {
      const formData = {
        chainId: parseInt(String(formValues.chainId), 10),
        url: formValues.url,
        active: formValues.active,
        type: formValues.type,
        score: parseFloat(String(formValues.score)),
      }
      const response = await callApi('/web3/rpc-endpoints', formData, 'POST')
      if (response) onSuccess()
    } catch (error) {}
  }

  return (
    <Form onSubmit={handleFormSubmit}>
      {message !== '' ? (
        <FeedbackBanner>
          <span>{message}</span>
          <CloseBtn onClick={() => setMessage('')}>✕</CloseBtn>
        </FeedbackBanner>
      ) : (
        <>
          <FieldGrid>
            <CustomInput
              type="number"
              label="Chain ID"
              name="chainId"
              modal
              value={formValues.chainId}
              onChange={(e: any) => setFormValues({ ...formValues, chainId: parseInt(e.target.value, 10) })}
              required
            />
            <CustomInput
              type="text"
              label="URL"
              name="url"
              modal
              value={formValues.url}
              onChange={(e: any) => setFormValues({ ...formValues, url: e.target.value })}
              required
            />
            <CustomInput
              type="text"
              label="Type"
              name="type"
              modal
              value={formValues.type}
              onChange={(e: any) => setFormValues({ ...formValues, type: e.target.value })}
              required
            />
            <CustomInput
              type="number"
              label="Score"
              name="score"
              modal
              value={formValues.score}
              onChange={(e: any) => setFormValues({ ...formValues, score: e.target.value })}
              required
            />
            <SwitchField>
              <SwitchLabel>Active</SwitchLabel>
              <MiniSwitch ison={formValues.active} onToggle={() => setFormValues(v => ({ ...v, active: !v.active }))} />
            </SwitchField>
          </FieldGrid>
          <SubmitBtn type="submit">Add RPC</SubmitBtn>
        </>
      )}
    </Form>
  )
}

export default Web3Form

// ─── Styles ──────────────────────────────────────────────────────────────────

const Form = styled.form`display: flex; flex-direction: column; gap: 16px;`
const FieldGrid = styled.div`display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 8px; align-items: start;`
const SwitchField = styled.div`display: flex; flex-direction: column; gap: 8px;`
const SwitchLabel = styled.label`font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: #777;`
const SubmitBtn = styled.button`height: 34px; padding: 0 16px; align-self: flex-start; background: rgba(111,92,230,0.15); border: 1px solid rgba(111,92,230,0.35); border-radius: 6px; color: #a89aff; font-size: 13px; font-weight: 500; cursor: pointer; transition: background 0.15s, border-color 0.15s; &:hover { background: rgba(111,92,230,0.25); border-color: rgba(111,92,230,0.5); }`
const FeedbackBanner = styled.div`display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; background: rgba(51,194,176,0.08); border: 1px solid rgba(51,194,176,0.25); border-radius: 6px; color: #33C2B0; font-size: 13px;`
const CloseBtn = styled.button`background: transparent; border: none; color: inherit; cursor: pointer; font-size: 12px; opacity: 0.7; &:hover { opacity: 1; }`
